import { productCatalogue } from '../catalogue/products';

export function productInfo(productId: string): { productName: string; logo: string | null } {
  const entry = productCatalogue.find((p) => p.key === productId);
  return { productName: entry?.name ?? productId, logo: entry?.logo ?? null };
}
